<template>
  <div class="download">
    <BaseListPage
        :name="name"
        :no-condition="false"
        :store-path="storePath"
        :table-set-list="tableSetList"
        :table-data-list="sortedList"
        :show-search-component="false"
        :show-custom-search-component="true"
        title="ダウンロード"
        title-class="download-header"
        icon="download">
      <DownloadConditionModal
          slot="customSearchComponent"
          :store-path="storePath"
          :res-path="responsePath"
          :save-key="saveKey"
          @getLatest="onGetLatest" />
    </BaseListPage>
  </div>
</template>
<style>
.download tr:hover td {
  background-color: initial !important;
}
</style>
<script>
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'
import _ from 'lodash'
import * as define from '@/define'
import * as query from '@/queries/download'
import common from '@/utils/common'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import * as config from '@/config'
import message from '@/utils/message'

import x from '@/components/mixins/mixin'
import BaseListPage from '@/components/organisms/BaseListPage'
import DownloadConditionModal from '@/components/pages/upload_download/download/DownloadConditionModal'

const STATUS = Object.freeze({
  PROCESSING: 0,
  COMPLETE: 1,
  ERROR: 9
})

let timer = null

export default {
  name: 'DownloadTop',
  components: {
    BaseListPage,
    DownloadConditionModal
  },
  mixins: [x],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      componentKey: 0
    }
  },
  computed: {
    define: () => define,
    ...mapGetters({
      getSortedList: 'sortedList'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    ...mapState({
      tdLists: (state) => state.Download.tdLists
    }),
    name () {
      return 'downloadTop'
    },
    storePath () {
      return 'Download'
    },
    saveKey () {
      return 'downloadCondition'
    },
    responsePath () {
      return 'data.accounts'
    },
    linkKey () {
      return 'uuid'
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    tableSetList () {
      return [
        { type: 'String', label: 'ファイル種類', path: 'templateDisplayValue', sortable: 'custom', width: 200 },
        { type: 'Date', label: 'リクエスト日時', path: 'createdAt', sortable: 'custom', width: 200 },
        { type: 'String', label: '条件', path: this.dispCondition, class: 'line-break', elementType: ELEMENT_TYPE.FUNCTION,
          lineBreak: true },
        { type: 'String', label: 'ステータス', path: this.rowStatus, elementType: ELEMENT_TYPE.FUNCTION,
          sortable: 'custom', width: 200 },
        { type: 'String', label: '', path: this.downloadLink, elementType: ELEMENT_TYPE.LINK, width: 250,
          onLinkClick: this.linkClick, class: 'visitedlinkNoChangeColor' }
      ]
    }
  },
  watch: {
    tdLists: {
      handler: function (val, oldVal) {
        // 再描画
        this.componentKey += 1
      },
      deep: true
    }
  },
  async created () {
    this.$loadingService.show()
    try {
      // 一覧とページを初期化
      const tdLists = this.storePath + '/tdLists'
      const currentPage = this.storePath + '/currentPage'
      this.$store.dispatch({
        type: 'set',
        states: {
          [tdLists]: [],
          [currentPage]: 0
        }
      })
      // 一覧情報取得
      await this.getDownloadControlData()
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  beforeRouteLeave (to, from, next) {
    // 非同期処理の初期化
    if (timer) {
      clearInterval(timer)
      timer = null
    }

    next()
  },
  methods: {
    async linkClick (displayItem) {
      this.$loadingService.show()
      try {
        const url = config.GET_DOWNLOAD_URL + '/' + displayItem.uuid + '/1'
        const method = 'get'
        const response = await common.apiAxios(url, { method })

        // 署名付きURLへ
        window.location.href = response.data.URL
      } catch (error) {
        common.addError(error, { msg: message.MSG_527() })
        this.$notify.error({ error: error })
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    downloadLink: function (row) {
      if (row.statusCode === 1 && row.filePath) {
        const filePathArray = row.filePath.split('/')
        return filePathArray[filePathArray.length - 1]
      }
      return ''
    },
    rowStatus: function (row) {
      switch (row.statusCode) {
        case 0: return '処理中'
        case 1: return 'ダウンロード可能'
        case 8: return 'タイムアウト'
        case 9: return 'エラー'
      }
      return ''
    },
    dispCondition: function (row) {
      // TODO 条件マスタ実装に伴い汎用的にする
      if (!row.condition) {
        return ''
      }
      const condition = JSON.parse(row.condition)
      let returnValue = ''

      // 動的検索条件を編集する
      Object.keys(condition).forEach((key) => {
        // 属性の場合
        if (key === 'xAttribute') {
          const searchKey = condition['xAttribute']['searchKey']
          const conditionValue = condition['xAttribute']['conditionValue']
          // 検索キー対応の条件を取得
          const searchCondition = this.$store.state.convertedSearchConditions[searchKey]
          conditionValue.forEach(obj => {
            const key = obj['key']
            const name = searchCondition[key]['title']
            const options = searchCondition[key]['options']
            let text = ''
            obj['value'].forEach(val => {
              text += text !== '' ? ',' : ''
              text += options.find(opt => opt.code === val)['name']
            })
            returnValue += ' ' + name + ': ' + text

          })
        } else {
          // 検索キー対応の条件を取得
          const searchCondition = this.$store.state.convertedSearchConditions[row.searchConditionRefKey]

          // key末尾のfrom または toはendwithで取り除く
          let replaceKey = key
          let isFrom = false
          let isTo = false
          if (replaceKey.endsWith('From')) {
            replaceKey = replaceKey.slice(0, -'From'.length)
            isFrom = true
          } else if (replaceKey.endsWith('To')) {
            replaceKey = replaceKey.slice(0, -'To'.length)
            isTo = true
          }
          const name = searchCondition[replaceKey].title
          const options = searchCondition[replaceKey].options
          const type = searchCondition[replaceKey].type
          let value = condition[key]

          // type毎に変換する
          switch (type) {
            case 'Input':
            case 'Number':
            case 'NumberRange':
              // 変換なし
              break
            case 'Date':
            case 'DateTime':
              // 日付・日時型の場合、ブラウザのタイムゾーンに変換する
              value = isTo ? Vue.filter('formatter')(Date.parse(condition[key]) - 1000, // +1秒さしてポストしていたので、表示は-1秒する
                'Date', { dateFormat: 'YYYY/MM/DD HH:mm:ss' })
                : Vue.filter('formatter')(condition[key],
                  'Date', { dateFormat: 'YYYY/MM/DD HH:mm:ss' })
              break
            case 'SingleSelector':
              // 選択肢は表示名に変換
              value = options.find(opt => String(opt.code) === String(value))['name']
              break
            case 'MultiSelector':
              // 選択肢は表示名に変換
              const optionValue = []
              value.forEach(val => {
                const option = options.find(opt => String(opt.code) === String(val))['name']
                optionValue.push(option)
              })
              value = optionValue.join(', ')
              break
          }

          // From または To の場合特殊処理を行う
          if (isFrom) {
            returnValue += ` ${name}: ${value} ~ `
          } else if (isTo) {
            returnValue += `${value} `
          } else {
            returnValue += ` ${name}: ${value} `
          }
        }
      })

      return returnValue === '' ? 'なし' : returnValue
    },
    async getDownloadControlData () {
      // 非同期処理の初期化
      if (timer) {
        clearInterval(timer)
        timer = null
      }
      const tdLists = this.storePath + '/tdLists'
      const currentPage = this.storePath + '/currentPage'
      const res = await common.postGraphQl(query.GRAPH_QL_QUERY_DOWNLOAD_CONTROLS)
      const resValue = common.getValueByPath(res.data, 'data.downloadControl')
      this.$store.dispatch({
        type: 'set',
        states: {
          [ tdLists ]: resValue,
          [ currentPage ]: 0
        }
      })
      if (resValue.some((data) => { return data.statusCode === STATUS.PROCESSING })) {
        timer = setInterval(() => {
          this.getLatestData()
          if (!resValue.some((data) => { return data.statusCode === STATUS.PROCESSING })) {
            clearInterval(timer)
            timer = null
          }
        }, 5000)
      }
      return res
    },
    async getLatestData () {
      await Promise.all(this.tdLists.filter((data) => { return data.statusCode === STATUS.PROCESSING })
        .map(async (data, index) => {
          const sql = common.addGraphQlCondition(query.GRAPH_QL_QUERY_DOWNLOAD_CONTROL, { uuid: data.uuid })
          const res = await common.postGraphQl(sql)

          const resValue = common.getValueByPath(res.data, 'data.downloadControl')
          if (resValue[0] && resValue[0].statusCode !== STATUS.PROCESSING) {
            const tdLists = this.storePath + '/tdLists'
            let newTdLists = _.cloneDeep(this.tdLists)
            newTdLists.some((data) => {
              if (data.uuid === resValue[0].uuid) {
                data.statusCode = resValue[0].statusCode
                data.filePath = resValue[0].filePath
                return true
              }
              return false
            })
            this.$store.dispatch({
              type: 'set',
              states: {
                [ tdLists ]: newTdLists
              }
            })
          }
        }))
    },
    async getDownloadControlDataByUuid (uuid) {
      const sql = common.addGraphQlCondition(query.GRAPH_QL_QUERY_DOWNLOAD_CONTROL, { uuid: uuid })
      const res = await common.postGraphQl(sql)

      return res
    },
    async onGetLatest () {
      this.$loadingService.show()
      try {
        // 一覧情報取得
        await this.getDownloadControlData()
      } catch (error) {
        this.$notify.error({ error: error })
        throw error
      } finally {
        this.$loadingService.close()
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/pages/upload_download/download/DownloadTop.vue